/**
 * Created by Ning Jiang on 2021-05-27.
 */

import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {DeadwoodRip} from "../DeadwoodRip";

export class DeadwoodRipWinPresentation implements FlowStatePresentation {

    constructor() {}

    public async start(flowStateController:FlowStateController) {
        await DeadwoodRip.winPresentations.startInLine(flowStateController);
        flowStateController.finish();
    }
}